(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-megamenu"] && !Shopify.designMode) return;
  try {
    class MegamenuBlurHandler {
    constructor() {
      this.blurElements = document.querySelectorAll('[data-megamenu-blur]');
      this.init();
    }

    init() {
      this.blurElements.forEach(blurElement => {
        blurElement.addEventListener('mouseenter', () => {
          this.closeMegamenu(blurElement);
        });
      });
    }

    closeMegamenu(blurElement) {
      // Bu blur elementine ait megamenu'yu bul
      const megamenu = blurElement.closest('.megamenu');

      if (megamenu) {
        // display none yerine class ekleyerek gizle
        megamenu.classList.add('megamenu--hidden');
      }

      // Bu megamenu'nun parent header menu item'ını bul ve hover state'ini kaldır
      const headerMenuItem = megamenu?.closest('.header__menu-item');
      if (headerMenuItem) {
        headerMenuItem.classList.remove('hover');
        // CSS hover state'ini de kaldırmak için
        headerMenuItem.style.pointerEvents = 'none';
        setTimeout(() => {
          headerMenuItem.style.pointerEvents = '';
        }, 100);
      }
    }
  }

  // DOM yüklendiğinde handler'ı başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MegamenuBlurHandler();
    });
  } else {
    new MegamenuBlurHandler();
  }
  } catch(e) { console.error(e); }
})();

})();
